import React from 'react';

import ScheduleTable from '../../components/Table/ScheduleTable';


const Schedules = () => (
  <div className="content">
    <ScheduleTable />
  </div>
);

export default Schedules;


// WEBPACK FOOTER //
// ./src/pages/Schedules/index.js